import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export default function MarkTypeSelector({ mark_types = [], type_id, onChange }) {
  const handleChange = (e) => {
    if (e.target.value !== undefined && onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <FormControl variant="standard" sx={{ width: '100%', mb: 2.5, mt: 0.5 }}>
      <InputLabel sx={{ fontWeight: 'bold' }}>Odaberite tip ocjene</InputLabel>
      <Select value={type_id} onChange={handleChange}>
        {mark_types.map((type) => (
          <MenuItem value={type.id} key={type.id}>{type.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
